export class FilterSelectEvent extends Event {
  static EVENT_TYPE = 'aesthetics-person-list__filter-select-event'
  constructor(eventInitDict?: EventInit,) {
    super(FilterSelectEvent.EVENT_TYPE, eventInitDict);
  }
}
